export default __webpack_public_path__ + "static/media/inviteFeed.3156b8cc.png";